(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dear-ally"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const root = document.querySelector('.da-site');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(document.getElementById('dear-ally-data').textContent);
    const keys = Object.keys(config.months);
    let month = 'december', item = 'letter', solution = false;
    let step = 1, firstIssue = month, consent = false, opener = null;
    const get = id => root.querySelector('#' + id);
    const art = get('sample-art'), dialog = get('join-dialog'), journey = get('journey-content');
    const renderSample = () => {
      const issue = config.months[month];
      get('mobile-sample-select').value = item;
      get('sample-label').textContent = config.labels[item];
      art.innerHTML = item === 'activity' && solution ? issue.solution : issue.samples[item];
      get('theme-date').textContent = issue.date;
      get('theme-title').textContent = issue.title;
      get('theme-description').textContent = issue.description;
      get('contents-list').innerHTML = issue.contents_html;
      get('month-panel').setAttribute('aria-labelledby', 'tab-' + month);
      root.querySelectorAll('[data-month]').forEach(tab => {
        const selected = tab.dataset.month === month;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      root.querySelectorAll('[data-item]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.item === item)));
    };
    root.querySelectorAll('[data-month]').forEach(tab => {
      tab.addEventListener('click', () => { month = tab.dataset.month; solution = false; renderSample(); });
      tab.addEventListener('keydown', event => {
        const index = keys.indexOf(month);
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % keys.length;
        if (event.key === 'ArrowLeft') target = (index + keys.length - 1) % keys.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = keys.length - 1;
        if (target !== undefined) { event.preventDefault(); const next = get('tab-' + keys[target]); next.click(); next.focus(); }
      });
    });
    get('contents-list').addEventListener('click', event => {
      const button = event.target.closest('[data-item]');
      if (!button) return;
      item = button.dataset.item; solution = false; renderSample();
      root.querySelector('[data-item="' + item + '"]').focus({ preventScroll: true });
    });
    get('mobile-sample-select').addEventListener('change', event => { item = event.target.value; solution = false; renderSample(); });
    art.addEventListener('click', event => {
      if (!event.target.closest('[data-solution]')) return;
      solution = !solution; renderSample();
      art.querySelector('[data-solution]').focus({ preventScroll: true });
    });
    const renderJourney = () => {
      journey.innerHTML = config.months[firstIssue].journey[step - 1];
      root.querySelectorAll('[data-step-marker]').forEach(marker => {
        if (Number(marker.dataset.stepMarker) === step) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
      });
      dialog.scrollTop = 0;
      get('dialog-title').focus({ preventScroll: true });
    };
    root.querySelectorAll('[data-join]').forEach(button => button.addEventListener('click', () => {
      opener = button; firstIssue = month; step = 1; consent = false;
      renderJourney(); dialog.showModal(); document.body.style.overflow = 'hidden'; get('dialog-title').focus();
    }));
    get('close-dialog').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.style.overflow = ''; if (opener) opener.focus({ preventScroll: true }); });
    journey.addEventListener('change', event => {
      if (step === 1 && event.target.name === 'first-issue' && config.months[event.target.value]) firstIssue = event.target.value;
      if (step === 2 && event.target.id === 'plan-consent') { consent = event.target.checked; journey.querySelector('[data-journey="complete"]').disabled = !consent; }
    });
    journey.addEventListener('click', event => {
      const button = event.target.closest('[data-journey]');
      if (!button || button.disabled) return;
      const action = button.dataset.journey;
      if (action === 'close') { dialog.close(); return; }
      if (action === 'next' && step === 1) step = 2;
      else if (action === 'back' && step === 2) { step = 1; consent = false; }
      else if (action === 'complete' && step === 2 && consent) step = 3;
      else return;
      renderJourney();
    });
    renderSample();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
